import PropTypes from 'prop-types';

const RenderValue = ({ children = null, isRender = true }) => {
  if (isRender) {
    return children;
  }
  return null;
};

RenderValue.propTypes = {
  children: PropTypes.element,
  isRender: PropTypes.bool
};

export default RenderValue;
